import React from "react";
import { useNavigate } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="pt-28 px-4 max-w-4xl mx-auto pb-24">
      <div className="bg-white rounded-3xl shadow p-6 sm:p-8 space-y-6">

        <div className="flex justify-between items-center">
          <h1 className="text-2xl sm:text-3xl font-bold">
            Terms & Conditions
          </h1>
          <button
            onClick={() => navigate(-1)}
            className="text-sm text-gray-500 hover:underline"
          >
            ← Back
          </button>
        </div>

        <p className="text-sm text-gray-600">
          Last updated: {new Date().toLocaleDateString()}
        </p>

       <section className="space-y-4 text-sm text-gray-700 leading-relaxed">

  <p>
    Welcome to <strong>Expeditio</strong> ("we", "our", "us"). By accessing or using
    our platform, you agree to be bound by these Terms & Conditions.
    Expeditio provides AI-powered travel planning, trip management,
    and collaborative itinerary tools.
  </p>

  {/* 1 */}
  <h2 className="font-semibold text-gray-900">1. Description of Service</h2>
  <p>
    Expeditio is a travel management platform that allows users to:
  </p>
  <ul className="list-disc ml-5 space-y-1">
    <li>Generate AI-powered travel itineraries</li>
    <li>Organize and manage trips</li>
    <li>Collaborate with friends or co-travelers in real-time</li>
    <li>Share trips via links or QR codes</li>
  </ul>
  <p>
    We do not directly provide bookings, ticketing, or payment services.
  </p>

  {/* 2 */}
  <h2 className="font-semibold text-gray-900">2. Eligibility</h2>
  <p>
    You must be at least 13 years old to use this platform.
    Users under 18 must have parental or guardian consent.
  </p>

  {/* 3 */}
  <h2 className="font-semibold text-gray-900">3. User Accounts</h2>
  <p>
    You may create an account using email or third-party authentication
    (e.g., Google).
  </p>
  <p>
    You are responsible for maintaining account security and all activity
    under your account.
  </p>

  {/* 4 */}
  <h2 className="font-semibold text-gray-900">4. Collaboration & Shared Trips</h2>
  <p>
    Expeditio enables collaborative trip planning. By sharing a trip:
  </p>
  <ul className="list-disc ml-5 space-y-1">
    <li>Other users may view and edit your itinerary</li>
    <li>All collaborators can see updates and modifications</li>
    <li>You are responsible for managing access permissions</li>
  </ul>
  <p>
    We are not responsible for unintended sharing or edits made by collaborators.
  </p>

  {/* 5 */}
  <h2 className="font-semibold text-gray-900">5. AI-Generated Content</h2>
  <p>
    Itineraries are generated using artificial intelligence and are
    for informational purposes only.
  </p>
  <p>
    We do not guarantee accuracy, availability, pricing, or real-time updates.
    Users must verify all travel details independently.
  </p>

  {/* 6 */}
  <h2 className="font-semibold text-gray-900">6. Tokens & Digital Credits</h2>
  <p>
    Some features may require tokens or usage credits.
  </p>
  <ul className="list-disc ml-5 space-y-1">
    <li>No monetary value</li>
    <li>Non-transferable</li>
    <li>Non-refundable</li>
    <li>Subject to change or removal</li>
  </ul>

  {/* 7 */}
  <h2 className="font-semibold text-gray-900">7. Shared Links & QR Access</h2>
  <p>
    Shared links or QR codes provide access to itineraries.
    You are responsible for how these links are shared.
  </p>

  {/* 8 */}
  <h2 className="font-semibold text-gray-900">8. Acceptable Use</h2>
  <p>You agree not to:</p>
  <ul className="list-disc ml-5 space-y-1">
    <li>Use the platform for illegal or harmful activities</li>
    <li>Attempt to hack, disrupt, or reverse engineer the system</li>
    <li>Misuse collaboration features or spam other users</li>
    <li>Exploit AI outputs for misleading or harmful purposes</li>
  </ul>

  {/* 9 */}
  <h2 className="font-semibold text-gray-900">9. Intellectual Property</h2>
  <p>
    All platform design, code, branding, and content belong to Expeditio.
    Unauthorized use, copying, or distribution is prohibited.
  </p>

  {/* 10 */}
  <h2 className="font-semibold text-gray-900">10. Third-Party Services</h2>
  <p>
    Expeditio may integrate or reference third-party services such as
    maps, authentication providers, or travel data sources.
  </p>
  <p>
    We are not responsible for third-party services or their policies.
  </p>

  {/* 11 */}
  <h2 className="font-semibold text-gray-900">11. Limitation of Liability</h2>
  <p>
    The platform is provided "as is" without warranties of any kind.
  </p>
  <p>
    We are not liable for:
  </p>
  <ul className="list-disc ml-5 space-y-1">
    <li>Travel disruptions or incorrect recommendations</li>
    <li>Loss of data or collaboration conflicts</li>
    <li>Damages arising from use of the platform</li>
  </ul>

  {/* 12 */}
  <h2 className="font-semibold text-gray-900">12. Termination</h2>
  <p>
    We may suspend or terminate accounts that violate these Terms
    or misuse the platform.
  </p>

  {/* 13 */}
  <h2 className="font-semibold text-gray-900">13. Changes to Terms</h2>
  <p>
    We may update these Terms at any time. Continued use of the platform
    implies acceptance of updated Terms.
  </p>

  {/* 14 */}
  <h2 className="font-semibold text-gray-900">14. Contact Information</h2>
  <p>
    For any questions:
    <br />
    <strong>Email:</strong> expeditio.travel@gmail.com
  </p>

</section>


      </div>
    </div>
  );
};

export default Terms;
